module.exports = __webpack_public_path__ + "static/3-531b479b774aad578629df6fa2c3be43.jpg";